import React from 'react';
import Modal from '@material-ui/core/Modal';
import { useGeneral } from '../../Context/GeneralContext';
import '../../styles/modalConfirm.css';
import { Button } from '@material-ui/core';
import { LetterX } from 'tabler-icons-react';

export default function ModalTermEsp() {
    const { setOpenTermEsp, openTermEsp, setConfirmTermEsp } = useGeneral();

    const handleClose = () => {
        setOpenTermEsp(false);
    };

    const handleConfirmar = () => {
        handleClose();
        setConfirmTermEsp(true);
    };

    const body = (
        <div className="modalConf-paper modalConf-paper--iniEsp">
            <div className="modalConf-head modalConf-head--iniEsp">
                <div className="modalConf-text">
                    <h4 className="modalConf-text-field">Terminar Paro Autorizado</h4>
                </div>
                <div className="modalConf-exit">
                    <LetterX
                        size={22}
                        color={'#ffffff'}
                        onClick={handleClose}
                        className="modalConf-exit-icon"
                    />
                </div>
            </div>
            <div className="modalConf-body">
                <div className="modalConf-body-text">
                    <h1>¿Está seguro que desea terminar el paro autorizado?</h1>
                </div>
                <div className="modalConf-body-buttons">
                    <div className="modalConf-body-buttons-first">
                        <Button
                            className="modalM-body-buttonS modalM-body-buttonS--iniEsp"
                            onClick={handleConfirmar}
                        >
                            <h1>Confirmar</h1>
                        </Button>
                    </div>

                    <div className="modalConf-body-buttons-second">
                        <Button
                            className="modalM-body-buttonC modalM-body-buttonC--iniEsp"
                            onClick={handleClose}
                        >
                            <h1>Cancelar</h1>
                        </Button>
                    </div>
                </div>
            </div>
        </div>
    );

    return (
        <div>
            <Modal
                open={openTermEsp}
                onClose={handleClose}
                aria-labelledby="simple-modal-title"
                aria-describedby="simple-modal-description"
            >
                {body}
            </Modal>
        </div>
    );
}
